import React from 'react'
import ReactDOM from 'react-dom/client'
import '@fontsource-variable/roboto-mono'
import './index.css'
import App from './App'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
